import withMetric from 'containers/withMetric'

const metricData = (props) => {
  const { studioId, pageId } = props
  return { studioId, pageId }
}

export default withMetric('skillGroupTypeView', metricData)
